import { apiClient } from 'api/client/apiClient';
import { AccessTableDTO } from '../types';
import { API_URLS } from '../consts';

export const fetchAccessTables = async () => {
  const result = await apiClient.get<AccessTableDTO[]>(`${API_URLS.Tables}/tables`);

  return result.data;
};
